import clsx from 'clsx';
import dayjs from 'dayjs';
import Link from 'next/link';
import objectComponentCard from './_styles/object/component/card.module.scss';
import pageRegistration from './_styles/page/registration.module.scss';

export const OutOfServiceAnnouncement = () => {
  const pRegistrationWrapperClass = clsx(
    objectComponentCard['c-card'],
    pageRegistration['p-registration-wrapper']
  );

  return (
    <>
      {dayjs().isBetween('2023-12-18', '2024-01-04', null, '[]') && (
        <div className={pRegistrationWrapperClass}>
          <h3>お知らせ</h3>
          <p>
            年末年始の休業期間は2023/12/27(水) ~ 2024/01/04(木)となります。
            年末年始期間中のお問い合わせは年明けの営業開始日以降、順次ご回答いたします。
            詳しくは
            <Link
              target="_blank"
              href="https://signate.co.jp/news/2023/202312181100.html"
              rel="noreferrer"
            >
              こちら
              <i className="fa fa-external-link-alt mg-l-5"></i>
            </Link>
          </p>
        </div>
      )}
      <style>
        {`
        .mg-l-5 {
          margin-left: 5px;
        }
      `}
      </style>
    </>
  );
};
